import type { Calculation } from "~/tools/calculate-value-from-points";
import type { FormatterUnit } from "~/tools/formatter-unit";

import { HEALTHY as HEALTHY_COLOR } from "../color/settings";
import type { Step as ThresholdsStep } from "../thresholds/settings";

interface Settings {
	unit?: string;
	decimals?: number;
	sparkline?: boolean;
	calculation?: Calculation;
	metricLabel?: string;
	fontSize?: number;
	color?: string;
	thresholds?: ReadonlyArray<ThresholdsStep>;
}

const DEFAULT = {
	unit: "short" satisfies FormatterUnit,
	decimals: undefined,
	sparkline: true,
	calculation: "last",
	metricLabel: undefined,
	fontSize: undefined,
	color: HEALTHY_COLOR,
	thresholds: [],
} as const satisfies Settings;

export { DEFAULT };
export type { Settings };
